
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/console/admin/company/[company_id]",
      function () {
        return require("private-next-pages/console/admin/company/[company_id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/console/admin/company/[company_id]"])
      });
    }
  